import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeCoords } from '@monorepo/models';

class GeocodingServices {
    private Base = pointer.geocoding;
    //
    GetCoordinatesFromAddress = async (address: string) => {
        const data = await api.SendRequest<{ coordinates: typeCoords; }>(`${this.Base}/address`, 'POST', { address });
        return data;
    }
    GetAddressFromCoordinates = async (coordinates: typeCoords) => {
        const data = await api.SendRequest<{ address: string; }>(`${this.Base}/coordinates`, 'POST', { coordinates });
        return data;
    }
    GetStreetFromCoordinates = async (coordinates: typeCoords) => {
        const data = await api.SendRequest<{ street: string; }>(`${this.Base}/street`, 'POST', { coordinates });
        return data;
    }
}

export const geocodingServices = new GeocodingServices();
